import React, {useEffect, useState} from "react";
import GenericButton from "../buttons/GenericButton";
import {UPDATE_SUB_ACTION} from "../../../constants";

const PlanUpdateSubscriptionRow = ({setPageType, showDowngrade = true, showUpgrade = true, showRecurrence = true}) => {
    return (
        <div className={'flexColumn update-subscription-body-div'} style={{alignSelf: "center"}}>
            <p style={{marginBottom:"0"}}>{i18n.payments.whichActionToPerform}</p>

            {
                showDowngrade && (
                    <GenericButton onClick={() => setPageType(UPDATE_SUB_ACTION.DOWNGRADE)}
                                   cssClasses={'update-subscription-btn'}
                                   text={i18n.payments.downgrade}/>
                )
            }

            {
                showUpgrade && (
                    <GenericButton onClick={() => setPageType(UPDATE_SUB_ACTION.UPGRADE)}
                                   cssClasses={'update-subscription-btn'}
                                   text={i18n.payments.upgrade}/>
                )
            }

            {
                showRecurrence && (
                    <GenericButton onClick={() => setPageType(UPDATE_SUB_ACTION.RECURRENCE)}
                                   cssClasses={'update-subscription-btn'}
                                   text={i18n.payments.updateRecurrence}/>
                )
            }
        </div>
    );
};

export default PlanUpdateSubscriptionRow;